export default "__VITE_ASSET__1a2b0653__"